import { Address } from "./address.tsx";

export class BillingDetails {
    private address: Address | null | undefined;
    private email: string | null | undefined;
    private name: string | null | undefined;
    private phone: string | null | undefined;
    private tax_id: string | null | undefined;

    constructor(address: Address | null | undefined, email: string | null | undefined, name: string | null | undefined, phone: string | null | undefined, tax_id: string | null | undefined) {
        this.setAddress(address);
        this.setEmail(email);
        this.setName(name);
        this.setPhone(phone);
        this.setTaxId(tax_id);
    }

    static fromJson(json:any) {
        return new BillingDetails(json.address !== null && json.address !== undefined ? Address.fromJson(json.address) : null, json.email, json.name, json.phone, json.tax_id);
    }

    setAddress(newAddress:Address | null | undefined) {
        this.address = newAddress;
    }
    setEmail(newEmail:string | null | undefined) {
        this.email = newEmail;
    }
    setName(newName:string | null | undefined) {
        this.name = newName;
    }
    setPhone(newPhone:string | null | undefined) {
        this.phone = newPhone;
    }
    setTaxId(newTaxId:string | null | undefined) {
        this.tax_id = newTaxId;
    }

    getAddress() {
        return this.address;
    }
    getEmail() {
        return this.email;
    }
    getName() {
        return this.name;
    }
    getPhone() {
        return this.phone;
    }
    getTaxId() {
        return this.tax_id;
    }
}